module.exports = __webpack_public_path__ + "static/media/20170806_01day_0030AT.fde4cf4c.jpg";